import React, { useRef, useState, useEffect } from "react";
import TextInput from "../../Components/TextInput/TextInput";
import styles from "./AddContacts.module.css";
import { FaUser } from "react-icons/fa";
import {
  aphabetValidator,
  emailValidate,
  phoneValidate,
} from "../../Values/validatorsnew";
import { connect, useDispatch } from "react-redux";

import {
  contactResources,
  createContacts,
  fetchConstants,
  fetchpropertySubType,
  createLead,
  contactResourcesMongo
} from "../../Services/contacts";
import moment from "moment";
import Loading from "../../Components/Loading/Loading";
import { AiOutlineClose } from "react-icons/ai";
import { showSnackbarAction } from "../../Redux/actions";
import { addContactFilterValue, country_code, url } from "../../Values/constants";
import Select from "react-select";
import Dropdown from "../../Components/DropDown/Dropdown";
import { useLocation } from "react-router";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics } from "../../Services/users";
import { getLocationData } from "../../Services/resources";
import DropDownWithDisplayName from "../../Components/DropDown/DropDownWithDisplayName";
const Requirement=[
  "NEW PROJECT",
  "RENTAL",
  "RESALE"
];

const AddContacts = ({
  history,
  user,
  organizationUsers,
  role,
  theme,
  authToken,
  organizationData,
  constants,
  organizationResources,
  mbConstants
}: {
  history: any;
  user: any;
  organizationUsers: any;
  role: string;
  theme: any;
  authToken:any;
  organizationData:any;
  constants:any,
  organizationResources:any;
  mbConstants:any
}) => {
  const dispatcher = useDispatch();
  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const numberRef: any = useRef();
  const emaileRef: any = useRef();
  const dateRef: any = useRef();
  const ansdateRef: any = useRef();
  const alternateRef: any = useRef();
  const unitRef:any = useRef()
  const cityRef:any = useRef()
  const [load, setLoad] = useState(false);
  const [constantBudget, setConstantBudget] = useState<any[]>(mbConstants?.buyBudget?mbConstants?.buyBudget:[]);
  const [countryCodeList, setCountryCodeList] = useState<
    string[]
  >([]);
  const [countryCode, setCountryCode] =
    useState<string>("");
  const [note, setNote] = useState("");
  const [cusAdd, setCusAdd] = useState("");
  const [gender, setGender] = useState<any>(
    {
      label: "Select",
      value: "Select",
    }
  );
  const [marital, setMarital] = useState<any>(
    {
      label: "Select",
      value: "Select",
    }
  );
//  console.log("userrrrrrrrrrrrrrrrrrr",user)
  const noteRef: any = useRef();
  const [projectSelected, setProjectSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });

  const [locationSelected, setlocationSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [budgetSelected, setBudgetSelected] = useState<any>(
    {
      label: "Select",
      value: "Select",
    }
  );
  const [propertyTypeSelected, setPropertyTypeSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [leadTypeSelected, setLeadTypeSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [propertyStageSelected, setPropertyStageSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [nextFollowSelected, setNextFollowSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [
    propertySubTypeSelected,
    setPropertySubTypeSelected,
  ] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [leadSourceSelected, setLeadSourceSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });

  const [addSetSelected, setAddSetSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [campaignSetSelected, setCampaignSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [ownerSelected, setOwnerSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [businessVerticalSelected, setBusinessVerticalSelected] =
  useState<any>({
    label: "Select",
    value: "Select",
  });
  const [usersList, setUsersList] = useState([]);

  const [projectsList, setProjectsList] = useState<any[]>(
    []
  );
  const [locationsList, setLocationsList] = useState<any[]>(
    []
  );
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [propertyTypeList, setPropertyTypeList] = useState<
    any[]
  >([]);
  const [propertyStageList, setPropertyStageList] =
    useState<any[]>([]);
  const [leadTypeList, setleadTypeList] =
    useState<any[]>([]);
  const [nextFollowUpList, setnextFollowUpList] = useState<
    any[]
  >([]);
  const [notIntReasonList, setNotIntReasonList] = useState<
    any[]
  >([]);
  const [lostReasonList, setLostReasonList] = useState<
    any[]
  >([]);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<
    any[]
  >([]);
  const [leadSourceList, setLeadSourceList] = useState<
    any[]
  >([]);
  const [uidList, setUidList] = useState<any>();
  const [addSet, setAddSet] = useState<any[]>([]);
  const [requirement_Type, setRequirement_Type] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [campaign, setCampaign] = useState<any[]>([]);
  const [businessVerticalList, setBusinessVerticalList] = useState<any[]>(
    []
  );
  const [stateList, setStateList] = useState<any[]>(
    []
  );
  const [stateSelected, setStateSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });

    const [industrialTypes, setIndustrialTypes] = useState<any[]>([]);
    const [institutionalTypes, setInstitutionalTypes] = useState<any[]>([]);

    const [apiLocationData, setApiLocationData] = useState<any>([]);
    const [DropDownClicked, setDropDownClicked] = useState<any>([]);
    const [searchString, setSearchString] = useState<string>('');

useEffect(()=>{
  const apiFunc = async()=>{
    const apiLocationData = await getLocationData(searchString,DropDownClicked)
    setApiLocationData(apiLocationData)
  }
  if((locationsList?.length===0 || projectsList?.length===0 ) && searchString !=""){
    setApiLocationData([])
    apiFunc()
  }
},[locationsList,searchString,projectsList])

  useEffect(() => {
    if (requirement_Type.value === "RENTAL") {
      setConstantBudget(mbConstants?.rentBudget)
    }
    else {
      setConstantBudget(mbConstants?.buyBudget)
    }
  }, [requirement_Type]);

    // useEffect(()=>{
    //   console.log("RishabhConstants",constants)
    // },[constants])
    
    const constant = () => {
      if (constants) {
        const propertyStageValues = constants.propertyStage ? Object.values(constants.propertyStage) : [];
        const propertyTypeValues = constants.propertyType ? Object.values(constants.propertyType) : [];
        setPropertyStageList(propertyStageValues);
        setPropertyTypeList(propertyTypeValues);
    
        const nextFollowUpValues = constants.followUpType ? Object.values(constants.followUpType) : [];
        const notIntReasonValues = constants.notInterestedReason ? Object.values(constants.notInterestedReason) : [];
        const lostReasonValues = constants.lostReasons ? Object.values(constants.lostReasons) : [];
        setnextFollowUpList(nextFollowUpValues);
        setNotIntReasonList(notIntReasonValues);
        setLostReasonList(lostReasonValues);
      }
    };
    
    useEffect(() => {
      if (constants) {
        constant();
      }
    }, [constants]);
    
        
  useEffect(() => {
    if(authToken && user && user.uid){
      getLeadsFilterValues();
    }
  }, [authToken,user.uid]);

  const getLeadsFilterValues = async () => {
    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/leads/filterValues', {
      // uid: user.uid,
      showColumns:addContactFilterValue
    });
    setAddSet(res.data[0]?.addset);
    setCampaign(res.data[0]?.campaign);
  }

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
    if ((role === "Lead Manager" || user.profile === "Admin") && organizationUsers) {
      let uids: { [key: string]: string } = {};
      let data: any = [];
      organizationUsers.map((item: any) => {
        data.push(
          `${item.user_first_name} ${item.user_last_name}-${item.user_email}`
        );
        uids[item.user_email] = item.uid;
      });
      setUsersList(data);
      setUidList(uids);
    }
  }, [organizationUsers]);

  useEffect(()=>{
    if(organizationResources){
      organizationResources.forEach((val:any)=>{
        if(val.resource_type==="locations"){
          let loc:any=[]
          val["locations"].forEach((item:any)=>{
                loc.push(item.location)
          })
          setLocationsList(loc)
        }
        if(val.resource_type==="budgets"){
          let loc:any=[]
          val["budgets"].forEach((item:any)=>{
                loc.push(item.budget)
          })
          setBudgetsList(loc);
        }
  
        if(val.resource_type==="businessVertical"){
          let loc:any=[]
          val["businessVertical"].forEach((item:any)=>{
                loc.push(item.businessVertical)
          })
          setBusinessVerticalList(loc);
        }
        if(val.resource_type==="leadSources"){
          let loc:any=[]
          val["leadSources"].forEach((item:any)=>{
                loc.push(item.leadSource)
          })
          setLeadSourceList(loc);
        }
  
        if(val.resource_type==="comTypes"){
          let loc:any=[]
          val["comTypes"].forEach((item:any)=>{
                loc.push(item.comType)
          })
          setComTypes(loc);
        }
        if(val.resource_type==="resTypes"){
          let loc:any=[]
          val["resTypes"].forEach((item:any)=>{
                loc.push(item.resType)
          })
          setResTypes(loc);
        }
        if(val.resource_type==="industrialTypes"){
          let loc:any=[]
          val["industrialTypes"].forEach((item:any)=>{
                loc.push(item.industrialType)
          })
          setIndustrialTypes(loc);
        }
        if(val.resource_type==="institutionalTypes"){
          let loc:any=[]
          val["institutionalTypes"].forEach((item:any)=>{
                loc.push(item.institutionalType)
          })
          setInstitutionalTypes(loc);
        }
  
        if(val.resource_type==="states"){
          let loc:any=[]
          val["states"].forEach((item:any)=>{
                loc.push(item.state)
          })
          setStateList(loc);
        }
        
      })
    }
  },[organizationResources])

  useEffect(() => {
  //   const unsub = contactResources(
  //     user.organization_id,
  //     (data) => setLocationsList(data),
  //     (data) => setBudgetsList(data),
  //     () => {},
  //     (data) => setBusinessVerticalList(data),
  //     organizationData,
  //     () => {},
  //     (data) => setStateList(data),
  //   );

    // const unsubConst = fetchConstants(
    //   (data) => setNotIntReasonList(data),
    //   (data) => setLostReasonList(data),
    //   // (data) => setPropertyStageList(data),
    //   // (data) => setPropertyTypeList(data),
    //   (data) => setnextFollowUpList(data)
    // );
    let data = ["Data", "Leads"];
    setleadTypeList(data);
    // const unsubProperty = fetchpropertySubType(
    //   user.organization_id,
    //   (data) => setComTypes(data),
    //   (data) => setResTypes(data),
    //   (data) => setLeadSourceList(data),
    //   (data) => setIndustrialTypes(data),
    //   (data) => setInstitutionalTypes(data)
    // );

    // return () => {
    //   // unsub();
    //   unsubConst();
    //   // unsubProperty();
    // };
    // eslint-disable-next-line
  }, [user.organization_id]);

  useEffect(() => {
    contactResourcesMongo(
      user.organization_id,
      (data) => setProjectsList(data),
      () => {},
      organizationData,
    )
    // eslint-disable-next-line
  }, [user.organization_id]);

  useEffect(() => {
    if (propertyTypeSelected.value === "Commercial") {
      if(comTypes.length === 0){
        setPropertySubType(mbConstants?.commercial);
      }
      else{
        setPropertySubType(comTypes);
      }
    }
     else if (
      propertyTypeSelected.value === "Residential"
    ) {
      if(resTypes.length === 0){
        setPropertySubType(mbConstants?.residential);
      }
      else{
        setPropertySubType(resTypes);
      }
    } 
     else if (
      propertyTypeSelected.value === "Industrial"
    ) {
      setPropertySubType(industrialTypes);
    } 
     else if (
      propertyTypeSelected.value === "Institutional"
    ) {
      setPropertySubType(institutionalTypes);
    } 
    else {
      setPropertySubType([]);
    }
  }, [propertyTypeSelected]);

  useEffect(() => {
    let data: any[] = [];
    country_code.forEach((item) => {
      data.push(item.dial_code + " " + item.name);
    });
    setCountryCodeList(data);
  }, []);

  useEffect(() => {
    let selected: string[] = [];
    if (user.country) {
      selected = countryCodeList.filter((item) =>
        item
          .toLowerCase()
          .includes(user.country.toLowerCase())
      );
    } else {
      selected = countryCodeList.filter((item) =>
        item.toLowerCase().includes("+91")
      );
    }
    if (selected.length !== 0) {
      setCountryCode(selected[0]);
    }
  }, [user.country, countryCodeList]);

  const choice = () => {
    let data = countryCodeList.map((item: any) => ({
      value: item,
      label: item,
    }));

    return data;
  };
  const location: any = useLocation();
  const create = async (e: any) => {
    e.preventDefault();
    if (user.organization_id) {
      if (firstNameRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "First Name Required!!",
            "error"
          )
        );
        return;
      } else if (lastNameRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "Last Name Required!!",
            "error"
          )
        );
        return;
      } else if (numberRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "Mobile Number Required!!",
            "error"
          )
        );
        return;
      } 
      else if (numberRef?.current?.value?.length !== 10 && countryCode.split(" ")[0]==="+91") {
        dispatcher(
          showSnackbarAction(
            "Please Enter Valid Phone Number!!",
            "error"
          )
        );
        return;
      } 
      else if (
        emaileRef.current.value !== "" &&
        emailValidate(emaileRef.current.value) ===
        "Invalid Email"
      ) {
        dispatcher(
          showSnackbarAction("Invalid Email!!", "error")
        );
        return;
      } else if (!(leadTypeSelected.value === "Leads" || leadTypeSelected.value === "Data")) {
        dispatcher(
          showSnackbarAction(
            "Lead Type Required!!",
            "error"
          )  
        );
        return;
      }else if (leadSourceSelected.value==="Select"){
        dispatcher(
          showSnackbarAction(
            "Lead source Required!!",
            "error"
          )
        );
        return;
      }
      // else if (requirement_Type.value === "Select") {
      //   dispatcher(
      //     showSnackbarAction(
      //       "Requirement Type Required!!",
      //       "error"
      //     )
      //   );
      //   return;
      // }
       else if (countryCode === "") {
        dispatcher(
          showSnackbarAction(
            "Country Code Required!!",
            "error"
          )
        );
        return;
      }
      if(firstNameRef.current.value !== "" && aphabetValidator(firstNameRef.current.value) === "Invalid Name"){
          dispatcher(showSnackbarAction("Accepts only alphabet or alphanumeric combination In Name", "error"));
          return;
      }
      if(lastNameRef.current.value !== "" && aphabetValidator(lastNameRef.current.value) === "Invalid Name"){
          dispatcher(showSnackbarAction("Accepts only alphabet or alphanumeric combination In Name", "error"));
          return;
      }
      setLoad(true);
      let l = ownerSelected.value.split("-");
      let email = l[1];

      const country = country_code.find(
        (el: any) =>
          el.dial_code === countryCode.split(" ")[0]
      );

      createLead(
        user.organization_id,
        emaileRef.current.value,
        firstNameRef.current.value,
        lastNameRef.current.value,
        numberRef.current.value,
        user.user_first_name + " " + user.user_last_name,
        (role === "Lead Manager" || user.profile === "Admin")
          ? uidList[email] !== undefined
            ? uidList[email]
            : user.uid
          : user.uid,
        dispatcher,
        history,
        (role === "Lead Manager" || user.profile === "Admin")
          ? email !== undefined
            ? email
            : user.user_email
          : user.user_email,
        alternateRef.current.value,
        countryCode.split(" ")[0],
        (data: boolean) => setLoad(data),
        country ? country.name : "India",
        propertyTypeSelected.value === "Select"
          ? ""
          : propertyTypeSelected.value,
        propertyStageSelected.value === "Select"
          ? ""
          : propertyStageSelected.value,
        leadTypeSelected.value === "Select"
          ? "Data"
          : leadTypeSelected.value,
        locationSelected.value === "Select"
          ? ""
          : locationSelected.value,
        budgetSelected.value === "Select"
          ? ""
          : budgetSelected.value,
        projectSelected.value === "Select"
          ? ""
          : projectSelected.value,
        propertySubTypeSelected.value === "Select"
          ? ""
          : propertySubTypeSelected.value,
        leadSourceSelected.value === "Select"
          ? "Self Generated"
          : leadSourceSelected.value,
        addSetSelected.value === "Select"
          ? ""
          : addSetSelected.value,
        campaignSetSelected.value === "Select"
          ? ""
          : campaignSetSelected.value,
        noteRef.current.value,
        false,
        user.user_email,
        authToken,
        gender.value === "Select"
          ? ""
          : gender.value,
        marital.value === "Select"
        ? ""
        : marital.value,
        dateRef.current.value ? moment(dateRef.current.value).toDate() : "",
        ansdateRef.current.value ? moment(ansdateRef.current.value).toDate() : "",
        cusAdd,
        businessVerticalSelected.value === "Select"
        ? ""
        : businessVerticalSelected.value,
        stateSelected.value === "Select"
        ? ""
        : stateSelected.value,
        unitRef?.current?.value,
        requirement_Type.value,
        cityRef?.current?.value,
        budgetSelected.label === "Select"? "": budgetSelected.label,
      );
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const selectInputContainerStyles = { };
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const maxDate = new Date().toISOString().split('T')[0]; 
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing 'e', '.', and '-' keys if type is number
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleKeyDownNumber = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing 'e', '.', and '-' keys if type is number
    if (e.key === "e" || e.key === "." || e.key === "-") {
      e.preventDefault();
    }
  };
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Add_Contact_Screen',user)
      }
    }
  },[user])
  return (
    // <div className={styles.parent}>
    //   {load === true && <Loading />}
    //   <div className={styles.child}>
    //     <div className={styles.headerView}>
    //       <p className={styles.heading}>
    //         {" "}
    //         {"Add Contacts Details"}
    //       </p>
    //       <AiOutlineClose
    //         className={styles.closeIcon}
    //         size={25}
    //         onClick={() => history.replace("/")}
    //       />
    //     </div>
    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>First Name</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter first name"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={firstNameRef}
    //           >
    //             <FaUser color={"#808080"} />
    //           </TextInput>
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Last Name</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter last name"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={lastNameRef}
    //           >
    //             <FaUser color={"#808080"} />
    //           </TextInput>
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Mobile No.</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={numberRef}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Email ID</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Email"}
    //             style={{ backgroundColor: "#fff" }}
    //             validator={emailValidate}
    //             ref={emaileRef}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Alternate No.</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={alternateRef}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div
    //           className={styles.title}
    //           style={{ marginBottom: "3%" }}
    //         >
    //           <p className={styles.one}>Country Code</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <Select
    //             options={choice()}
    //             onChange={(data) => {
    //               if (data) {
    //                 setCountryCode(data.label);
    //               }
    //             }}
    //             isSearchable={true}
    //             value={{
    //               label: countryCode,
    //               value: countryCode,
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Location</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={locationsList}
    //             selectedValue={locationSelected}
    //             setSelectedValue={(value) => {
    //               setlocationSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Project</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={projectsList}
    //             selectedValue={projectSelected}
    //             setSelectedValue={(value) => {
    //               setProjectSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Property Type</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={propertyTypeList}
    //             selectedValue={propertyTypeSelected}
    //             setSelectedValue={(value) => {
    //               setPropertyTypeSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Property Stage</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={propertyStageList}
    //             selectedValue={propertyStageSelected}
    //             setSelectedValue={(value) => {
    //               setPropertyStageSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Budget</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={budgetsList}
    //             selectedValue={budgetSelected}
    //             setSelectedValue={(value) => {
    //               setBudgetSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>
    //             Property Sub Type
    //           </p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={propertySubType}
    //             selectedValue={propertySubTypeSelected}
    //             setSelectedValue={(value) => {
    //               setPropertySubTypeSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     {/* Add New Key  */}
    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Lead Type</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={leadTypeList}
    //             selectedValue={leadTypeSelected}
    //             setSelectedValue={(value) => {
    //               setLeadTypeSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>


    //     {user.profile === "Lead Manager" && (
    //       <div className={styles.box2}>
    //         <div className={styles.divide}>
    //           <div className={styles.title}>
    //             <p className={styles.one}>Lead Source</p>
    //             <p className={styles.two}></p>
    //           </div>
    //           <div style={{ marginTop: "7px" }}>
    //             <Dropdown
    //               option={leadSourceList}
    //               selectedValue={leadSourceSelected}
    //               setSelectedValue={(value) => {
    //                 setLeadSourceSelected(value);
    //               }}
    //             />
    //           </div>
    //         </div>
    //         <div className={styles.divide}>
    //           <div className={styles.title}>
    //             <p className={styles.one}>Owner</p>
    //             <p className={styles.two}></p>
    //           </div>
    //           <div style={{ marginTop: "7px" }}>
    //             <Dropdown
    //               option={usersList}
    //               selectedValue={ownerSelected}
    //               setSelectedValue={(value) => {
    //                 setOwnerSelected(value);
    //               }}
    //             />
    //           </div>
    //         </div>
    //       </div>
    //     )}

    //     {user.profile === "Team Lead" && (
    //       <div className={styles.box2}>
    //         <div className={styles.divide}>
    //           <div className={styles.title}>
    //             <p className={styles.one}>Lead Source</p>
    //             <p className={styles.two}></p>
    //           </div>
    //           <div style={{ marginTop: "7px" }}>
    //             <Dropdown
    //               option={leadSourceList}
    //               selectedValue={leadSourceSelected}
    //               setSelectedValue={(value) => {
    //                 setLeadSourceSelected(value);
    //               }}
    //             />
    //           </div>
    //         </div>
    //       </div>
    //     )}

    //     <div className={styles.box2}>
    //       <div
    //         className={styles.divide}
    //         style={{ width: "100%" }}
    //       >
    //         <div className={styles.title}>
    //           <p className={styles.one}>Add Note</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <textarea
    //             style={{
    //               width: "100%",
    //               resize: "none",
    //               marginTop: "17px",
    //             }}
    //             rows={4}
    //             cols={10}
    //             placeholder={"Enter Note"}
    //             ref={noteRef}
    //             onChange={(e) => setNote(e.target.value)}
    //             value={note}
    //           ></textarea>
    //         </div>
    //       </div>
    //     </div>

    //     <button
    //       className={styles.button}
    //       onClick={() => {
    //         console.log(user, "user");
    //         create();
    //       }}
    //     >
    //       Submit
    //     </button>
    //   </div>
    // </div>
    <div
      className={styles.parent}
      // className="container-fluid p-4 d-flex flex-column gap-4"
      style={containerStyles}
    >
      {load === true && <Loading />}
      <div
        //  className={styles.headerView}
        className="d-flex flex-row w-100 px-4 pt-4"
      >
        <h5
        // className={styles.heading}
        >
          {" "}
          {"Add Contacts Details"}
        </h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/")}
        />
      </div>
      <div
        // className={styles.child}
        className="w-100 d-flex flex-column gap-2 px-4"
      >
        <form className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Requirement Type" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={Requirement}
                  selectedValue={requirement_Type}
                  setSelectedValue={(value) => {
                    setRequirement_Type(value);
                    setBudgetSelected({
                      label: "Select",
                      value: "Select",
                    })
                  }}
                />
              </div>  
            </div>
            <div className={styles.divide}>
              <Label label="First Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={firstNameRef}
                  validator={aphabetValidator}
                >
                  <FaUser color={"#808080"} />
                </TextInput>
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Last Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={lastNameRef}
                  validator={aphabetValidator}
                  onKeyDown={handleKeyDown}
                >
                  <FaUser color={"#808080"} />
                </TextInput>
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Contact Number" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={numberRef}
                  type='number'
                  onKeyDown={handleKeyDownNumber}
                  minValue={"0"}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Country Code" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  className={styles.select}
                  options={choice()}
                  onChange={(data) => {
                    if (data) {
                      setCountryCode(data.label);
                    }
                  }}
                  isSearchable={true}
                  value={{
                    label: countryCode,
                    value: countryCode,
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Email ID" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  validator={emailValidate}
                  ref={emaileRef}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Alternate Number" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={alternateRef}
                  type='number'
                  onKeyDown={handleKeyDownNumber}
                  minValue={"0"}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="City" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={cityRef}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Project" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={projectsList?.length === 0?apiLocationData:projectsList}
                  selectedValue={projectSelected}
                  setSelectedValue={(value) => {
                    setProjectSelected(value);
                  }}
                  placeholder='Project'
                  isAutoSuggestionDropdown={true}
                  searchString={(value) => {
                    setDropDownClicked("PROJECT")
                    setSearchString(value);
                  }}
                  setApiLocationData={()=>{
                    setApiLocationData([])
                  }}
                />
              </div>
            </div>
          </div>
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Property Stage" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={propertyStageList}
                  selectedValue={propertyStageSelected}
                  setSelectedValue={(value) => {
                    setPropertyStageSelected(value);
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Property Type" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={propertyTypeList}
                  selectedValue={propertyTypeSelected}
                  setSelectedValue={(value) => {
                    setPropertyTypeSelected(value);
                    setPropertySubTypeSelected("Select");
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Property Sub Type" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={propertySubType}
                  selectedValue={propertySubTypeSelected}
                  setSelectedValue={(value) => {
                    setPropertySubTypeSelected(value);
                  }}
                />
              </div>
            </div>
          </div>
        }
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Budget" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
              {budgetsList.length===0?                
                <DropDownWithDisplayName
                  option={constantBudget}
                  selectedValue={budgetSelected}
                  setSelectedValue={(value) => {
                    setBudgetSelected(value);
                  }}
                />:
                <Dropdown
                option={budgetsList}
                selectedValue={budgetSelected}
                setSelectedValue={(value) => {
                  setBudgetSelected(value);
                }}
              />}
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Location" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={locationsList?.length === 0?apiLocationData:locationsList}
                  selectedValue={locationSelected}
                  setSelectedValue={(value) => {
                    setlocationSelected(value);
                  }}
                  placeholder='Location'
                  isAutoSuggestionDropdown={true}
                  searchString={(value) => {
                    setDropDownClicked("LOCATION")
                    setSearchString(value);
                  }}
                  setApiLocationData={()=>{
                    setApiLocationData([])
                  }}
                />
              </div>
              </div>
              <div className={styles.divide}>
              <Label label="Lead State" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={stateList.length===0?mbConstants.states:stateList}
                  selectedValue={stateSelected}
                  setSelectedValue={(value) => {
                    setStateSelected(value);
                  }}
                />
              </div>
              </div>
          </div>

          {/* Add New Key  */}
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Lead Type" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={leadTypeList}
                  selectedValue={leadTypeSelected}
                  setSelectedValue={(value) => {
                    setLeadTypeSelected(value);
                  }}
                />
              </div>
            </div>
              <div className={styles.divide}>
                <Label label="Lead Source" required={true} />
                <div style={{ ...selectInputContainerStyles }}>
                  <Dropdown
                    option={leadSourceList}
                    selectedValue={leadSourceSelected}
                    setSelectedValue={(value) => {
                      setLeadSourceSelected(value);
                    }}
                  />
                </div>

              </div>
            
              <div className={styles.divide}>
              <Label label="D.O.B" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
            <input
              type="date"
              placeholder="Enter Date"
              ref={dateRef}
              max={maxDate}
              // className={styles.dateInput}
            />
              </div>
            </div>
          
          </div>

          {(user.profile === "Lead Manager" || user.profile === "Admin") && (
            <>
              <div className={styles.box2}>
              <div className={styles.divide}>
                  <Label label="Lead Assignee Email" required={false} />
                  <div style={{ ...selectInputContainerStyles }}>
                    <Dropdown
                      option={usersList}
                      selectedValue={ownerSelected}
                      setSelectedValue={(value) => {
                        setOwnerSelected(value);
                      }}
                    />
                  </div>
                </div>
                <div className={styles.divide}>
                  <Label label="Add Set" required={false} />
                  <div style={{ ...selectInputContainerStyles }}>
                    <Dropdown
                      option={addSet}
                      selectedValue={addSetSelected}
                      setSelectedValue={(value) => {
                        setAddSetSelected(value);
                      }}
                    />
                  </div>
                </div>
                <div className={styles.divide}>
                  <Label label="Campaign" required={false} />
                  <div style={{ ...selectInputContainerStyles }}>
                    <Dropdown
                      option={campaign}
                      selectedValue={campaignSetSelected}
                      setSelectedValue={(value) => {
                        setCampaignSelected(value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Anniversary Date" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
            <input
              type="date"
              placeholder="Enter Date"
              ref={ansdateRef}
              max={maxDate}
              // className={styles.dateInput}
            />
              </div>
          </div>
          <div className={styles.divide}>
              <Label label="Gender" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={["Male","Female","Other"]}
                  selectedValue={gender}
                  setSelectedValue={(value) => {
                    setGender(value);
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Marital Status" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={["Married","Un-married"]}
                  selectedValue={marital}
                  setSelectedValue={(value) => {
                    setMarital(value);
                  }}
                />
              </div>
            </div>
          {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                          <div className={styles.divide } style={{marginRight:"35%"}}>
                          <Label label="Business Vertical" required={false} />
                          <div style={{ ...selectInputContainerStyles }}>
                            <Dropdown
                              option={businessVerticalList}
                              selectedValue={businessVerticalSelected}
                              setSelectedValue={(value) => {
                                setBusinessVerticalSelected(value);
                              }}
                            />
                          </div>
                        </div>
            )}
          </div>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Unit No." required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={unitRef}
                />
              </div>
            </div>
          </div>
          <div className={styles.box3}>
            <div
              // className={styles.divide}
              style={{ width: "100%" }}
            >
              <Label label="Customer Address" required={false} />
              <div>
                <textarea
                  // style={{
                  //   marginTop: "1rem",
                  // }}
                  className="form-control"
                  rows={2}
                  placeholder={""}
                  // ref={noteRef}
                  onChange={(e) => setCusAdd(e.target.value)}
                  value={cusAdd}
                ></textarea>
              </div>
            </div>
          </div>
          <div className={styles.box3}>
            <div
              // className={styles.divide}
              style={{ width: "100%" }}
            >
              <Label label="Add Note" required={false} />
              <div>
                <textarea
                  // style={{
                  //   marginTop: "1rem",
                  // }}
                  className="form-control"
                  rows={2}
                  placeholder={""}
                  ref={noteRef}
                  onChange={(e) => setNote(e.target.value)}
                  value={note}
                ></textarea>
              </div>
            </div>
          </div>

          <button
            type="submit"
            // className="btn btn-primary mt-5"
            style={{ backgroundColor: "#279f9f" }}
            className={styles.button}
            onClick={(e: any) => {
              // console.log(user, "user");
              create(e);
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    role: state.user.role,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    constants:state.constants.data,
    organizationResources:state.organizationResources.data,
    mbConstants:state?.mbConstant?.data
  };
};

export default connect(mapStateToProps)(AddContacts);
